<template>
  <div class="developer-incoming-files">
    <BaseCard
      :has-divider="true"
      :has-main-container="true"
      base-card-title-class="app-font-semibold title mb-1"
      data-v-step="0"
    >
      <template v-slot:header-title>
        Monitoramento de Operações
      </template>
      <template v-if="showExecutionDetail">
        <OperationInfo
          :is-program-context="true"
          class="ma-4"
        />
      </template>
      <template v-else>
        <v-row class="mt-4">
          <v-col sm="3">
            <v-select
              v-model="initiator"
              :items="getInitiators"
              label="Originador"
              clearable
              @click:clear="setFilter({ initiator: '' }); filterExecutionList()"
            />
          </v-col>
          <v-col
            sm="2"
            class="app-align-items-center"
          >
            <BaseButton
              type="text"
              color="blueff"
              class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
              @click="filterExecutionList()"
            >
              Filtrar
            </BaseButton>
          </v-col>
        </v-row>
        <BaseDataTable
          :headers="headers"
          :items="operationOverview"
          :hide-actions="false"
          background-color="transparent"
          :total-items="listRegisterOperationTotalItens"
          :options="pagination"
          @update-pagination="updatePagination"
        >
          <template v-slot:inject-items="scopedItems">
            <tr
              v-for="value in scopedItems"
              :key="value.index"
            >
              <td>
                <v-chip
                  class="list__item--status font-weight-medium"
                  :color="value.item.status.toLowerCase()"
                >
                  {{ parseStatusMessage(value.item.status) || '-' }}
                </v-chip>
              </td>
              <td>
                {{ value.item.createdAt | getDate }} - {{ value.item.createdAt | getFullTime }}
              </td>
              <td>
                {{ value.item.initiator }}
              </td>
              <td>
                {{ value.item.description }}
              </td>
              <td>
                <BaseButton
                  type="text"
                  color="blueff"
                  class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                  @click="openExecutionDetail(value.item.id)"
                >
                  Detalhes
                </BaseButton>
              </td>
            </tr>
          </template>
          <template v-slot:custom-text-no-data>
            <div class="text-center">
              Nenhuma operação existente no momento.
            </div>
          </template>
        </BaseDataTable>
      </template>
    </BaseCard>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import BaseDataTable from '../../BaseDataTable'
import OperationInfo from '../../OperationInfo'

export default {
  name: 'DeveloperIncomingFiles',
  components: { BaseDataTable, OperationInfo },
  data() {
    return {
      disabledFirstLoadUpdateDataTable: true,
      headers: [
        {
          text: 'Status',
          value: 'status',
          sortable: false,
          width: 130
        },
        {
          text: 'Data e Hora',
          value: 'createdAt',
          sortable: false,
          width: 150
        },
        {
          text: 'Originador',
          value: 'initiator',
          sortable: false
        },
        {
          text: 'Descrição',
          value: 'description',
          sortable: false
        },
        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
          width: 60
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getInitiators', 'getCurrentRegisterOperation']),
    ...mapState({
      pagination: (state) => state.operationRegister.pagination,
      currentOperationInfo: (state) => state.operationRegister.currentOperationInfo,
      listRegisterOperationTotalItens: (state) => state.operationRegister.listRegisterOperation.totalItems,
      listRegisterOperationExecution: (state) => state.operationRegister.listRegisterOperation.executions
    }),
    operationOverview(){
      if(this.listRegisterOperationExecution.length){
        return this.listRegisterOperationExecution
      } else {
        return  this.getCurrentRegisterOperation ? [ this.getCurrentRegisterOperation ] : []
      }
    },
    initiator: {
      get() {
        return this.$store.state.operationRegister.filter.initiator
      },
      set(value) {
        this.setFilter({initiator: value ? value : ''})
      }
    },
    showExecutionDetail() {
      return this.$route.params && this.$route.params.id
    }
  },
  async created(){
    this.getRegisterOperation();
    await this.apiGetInitiators();
  },
  methods: {
    ...mapActions(['apiGetInitiators', 'apiGetRegisterOperation', 'apiGetOperationInfoDiagram']),
    ...mapMutations(['setFilter', 'setPagination', 'setCurrentOperationInfo']),
    async openExecutionDetail(id){
      this.$router.push(`/developer/executions/${id}`)
    },
    updatePagination(pagination) {
      const reducePaginationAttributes = {
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage
      }
      this.setPagination(reducePaginationAttributes)

      if (this.disabledFirstLoadUpdateDataTable) {
        this.disabledFirstLoadUpdateDataTable = false
        return
      }
      this.getRegisterOperation()
    },
    filterExecutionList(){
      this.setFilter({initiator: this.initiator})
      this.updatePagination({
        page: 1,
        itemsPerPage: this.pagination.itemsPerPage
      })
    },
    async getRegisterOperation(){
      await this.apiGetRegisterOperation();
    },
    parseStatusMessage(status) {
      switch (status.toLowerCase()) {
        case "ok":
          return "Sucesso"
        case "error":
          return "Erro"
        case "pending":
          return "Pendente"
        case "running":
          return "Em andamento"
        default:
          return status.charAt(0).toUpperCase() + status.toLowerCase().substring(1)
      }
    }
  }
}
</script>
